import React from "react";
import { Globe, Check } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useSite } from "@/i18n/SiteContext";
import { LANG_LABELS } from "@/i18n/strings";

export const LanguageSwitcher = ({ light = false }) => {
  const { lang, setLang } = useSite();
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger
        data-testid="language-switcher"
        className={`inline-flex items-center gap-1.5 text-xs font-medium tracking-wider uppercase px-3 py-2 rounded-full border btn-lift ${
          light ? "border-ivory/40 text-ivory hover:bg-ivory/10" : "border-ocean/20 text-ocean hover:border-sea"
        }`}
      >
        <Globe size={14} /> {lang.toUpperCase()}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[160px] bg-white">
        {Object.entries(LANG_LABELS).map(([code, label]) => (
          <DropdownMenuItem
            key={code}
            data-testid={`language-option-${code}`}
            onClick={() => setLang(code)}
            className="flex items-center justify-between cursor-pointer"
          >
            <span>{label}</span>
            {lang === code && <Check size={14} className="text-sea" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
